// removed by extract-text-webpack-plugin
module.exports = {"checkboxContainer":"s6_7AF9TmTDxu4aJsgg7g","label":"_2oqVWU77S3cSsoyGNzRcQp"};


/*****************
 ** WEBPACK FOOTER
 ** ./client/form/CheckboxField.css
 ** module id = 928
 ** module chunks = 1
 **/